import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Badge,
  Input,
  Table,
  Spinner,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import Modal from "react-bootstrap/Modal"
import ButtonSpinner from "../../components/ButtonSpinner"

//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"

//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as myClientAction from "../../store/bXljbGllbnRlYw/actions"
import * as permissionAction from "../../store/cGVybWlzc2lvbg/actions"
import * as manageEcAction from "../../store/TWFuYWdlRWM/actions"
import api from "helpers/Api"

const MyClientEc = (props) => {
  const title = "My Client EC"
  const { dispatch, searchBarStyle } = props

  const empId = localStorage.getItem("empId")
  console.log(empId, "employee id")

  useEffect(() => {
    dispatch(myClientAction.loadRecordsMetaData())
    dispatch(permissionAction.loadEmployee())
    dispatch(
      myClientAction.loadMyClientEcList({
        employeeId: empId,
        isManageEC: true,
        limit: 25,
        page: 1,
      })
    )
    function handleContextMenu(e) {
      e.preventDefault()
    }

    const rootElement = document.getElementById("my-component")
    rootElement.addEventListener("contextmenu", handleContextMenu)

    return () => {
      rootElement.removeEventListener("contextmenu", handleContextMenu)
    }
  }, [])

  //Reducer State maintenance
  const specificDispatch = useDispatch()
  const update = useSelector((specificstate) => specificstate)
  console.log(update, "update")

  const myClientUpdate = useSelector((state) => state.myClientEc)
  console.log(myClientUpdate, "manageUpdateEc")

  const { myClientMetaData = {}, manageEc_details = [] } = myClientUpdate

  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //manage Ec initial state
  const [myClientEcData, setMyClientEcData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    leadNo: "",
  })

  //handle change

  const handleChange = async (e) => {
    setMyClientEcData({ ...myClientEcData, [e.target.name]: e.target.value })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])

  //clearance modal state
  const [clearanceModal, setClearanceModal] = useState(false)
  const [clearanceHistoryModal, setClearanceHistoryModal] = useState(false)
  const [clearanceHistoryDetails, setClearanceHistoryDetails] = useState("")

  const handleClearanceHistory = () => setClearanceHistoryModal(false)

  const [leadId, setLeadId] = useState("")
  //alter checkbox
  const alterList = [
    {
      label: "Is Alter",
      value: true,
    },
  ]

  const [isAlter, setIsAlter] = useState("")
  const handleAlterChange = async (e, value) => {
    let isChecked = e.target.checked
    if (isChecked) {
      setIsAlter(value)
    } else {
      setIsAlter(false)
    }
  }
  //reset filter form

  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setEvents([])
    setIsAlter(false)
    setMyClientEcData({
      fromDate: "",
      toDate: "",
      leadNo: "",
    })
    dispatch(
      myClientAction.loadMyClientEcList({
        employeeId: empId,
        isManageEC: true,
        limit: 25,
        page: pageChange ? pageCount : 1,
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)

  //dropdown options

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const branchOptions =
    !isEmpty(myClientMetaData) &&
    myClientMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  //apply filter submit
  //Searchvalue
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  const [pageCount, setPageCount] = useState("")
  const [pageLoad, setPageLoad] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)

  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
      isManageEC: true,
      page: pageChange ? pageCount : 1,
      limit: 25,
      employeeId: empId,
    }
  console.log(searchValue, "searchValue")
  const eventValue = !isEmpty(events) && events.length > 0 ? events.map(val => val.value) : []

  const clientFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = !isEmpty(eventValue) && eventValue.length > 0 ? eventValue : ""
    var searchFromDate =
      myClientEcData && myClientEcData.fromDate
        ? moment(myClientEcData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      myClientEcData && myClientEcData.toDate
        ? moment(myClientEcData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      myClientEcData && myClientEcData.leadNo ? myClientEcData.leadNo : ""
    var searchAlter = isAlter
    var searchvalue = {}
    searchvalue.employeeId = empId
    searchvalue.isManageEC = true
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 25

    if (searchAlter) {
      searchvalue.isAlter = searchAlter
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }

    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setSearchValueList(searchvalue)
    specificDispatch(myClientAction.loadMyClientEcList(searchvalue))
    setBtnLoader(true)
    setDownloadLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setDownloadLoading(false)
    }, 2000)
  }
  //data table for manageEc

  let slNo = 0
  const myClientDataTable =
    !isEmpty(manageEc_details) && manageEc_details.data.length > 0
      ? manageEc_details.data.map((data, index) => {
        slNo = slNo + 1

        const leadDate = data.leadDate
          ? moment(data.leadDate)
            .subtract(5, "hours")
            .subtract(30, "minutes")
            .format(`${dateFormate} hh:mm A`)
          : []

        const eventCount =
          !isEmpty(data) && data.events.length > 0 ? data.events.length : 0

        const colorCode =
          data &&
            !isEmpty(data.ecProcessStatus) &&
            !isEmpty(myClientMetaData) &&
            myClientMetaData.processStatusOptions &&
            myClientMetaData.processStatusOptions.length > 0
            ? myClientMetaData.processStatusOptions.find(
              (_) => _.processStatusId === data.ecProcessStatus
            ) &&
            myClientMetaData.processStatusOptions.find(
              (_) => _.processStatusId === data.ecProcessStatus
            )
            : []
        console.log(colorCode, "colorCode")

        return {
          _id: data._id,
          sNo: slNo,
          leadNo: data.leadNo,
          colorCode: !isEmpty(colorCode) ? colorCode.colorCode : "",
          statusName: !isEmpty(colorCode) ? colorCode.label : "",
          routeData: data,
          branchId: data.branchId,
          branchName: data.branchName,
          leadServiceName: data.leadServiceName,
          leadSourceName: data.leadSourceName,
          eventDetails: data.events,
          leadType: data.leadType,
          paymentStatus: !isEmpty(data.paymentStatus)
            ? data.paymentStatus
            : "",
          salesUrge: data.salesUrge,
          clientName: !isEmpty(data.clientDetails)
            ? data.clientDetails.firstName + " " + data.clientDetails.lastName
            : "",
          brideName: data.brideName,
          groomName: data.groomName,
          clientCode: !isEmpty(data.clientDetails)
            ? data.clientDetails.clientNo
            : "",
          companyId: data.companyId,
          overallStatus: !isEmpty(data.overAllStatus)
            ? data.overAllStatus
            : "--",
          leadClearanceType: !isEmpty(data.leadClearance)
            ? data.leadClearance.type
            : "--",
          leadClearanceStatusId: !isEmpty(data.ecClearanceStatus)
            ? data.ecClearanceStatus
            : "",
          leadClearanceName: !isEmpty(data.ecClearanceStatusName)
            ? data.ecClearanceStatusName
            : "",
          allowOrderData: data.isAllowOrder,
          allowOrder: data.isAllowOrder === true ? "YES" : "NO",
          companyName: data.companyName,
          event: data.events,
          events: eventCount,
          salesAgentName: !isEmpty(data.leadAssign)
            ? data.leadAssign.assignedToName
            : "--",
          leadDate: leadDate,
          clearanceReport:
            data.ecProcessStatus !== "PS2" ? data.ecProcessStatusName : "--",
          leadStatus: data.ecProcessStatusName,
          processStatus: data.processStatus,
          ecProcessStatus: data.ecProcessStatus,
          ecProcessStatusName: data.ecProcessStatusName,
          key: index,
          createdAt: data.createdAt,
          leadClearanceHistory: data.leadClearanceHistory,
          alter: data.isAlter,
          cpRemarks: !isEmpty(data.clientDetails) ?
            data.clientDetails.profileRemarks : "--",
          cpStatus: !isEmpty(data.clientDetails) ?
            data.clientDetails.profileStatus : "--",
          clientType: data.leadQuotationRange,
          onlyEngagement: data.onlyEngagement,
          goodLookingClient: data.goodLookingClient,
          highEndClient: data.highEndClient
        }
      })
      : []

  //download feature in data table

  console.log(myClientDataTable, "leadId")
  //columns for data table
  const columns = [
    {
      dataField: "_id",
      text: "id",
      hidden: true,
      csvExport: false,

      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "sNo",
      text: "S.No",
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        color: "#e40d8c",
        textTransform: "uppercase",
      }),

      formatter: (cellContent, row) => {
        const leadData = row.routeData
        return (
          <div className={row.processStatus != "PS9" ? "disabled-button" : ""}>
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: { row: leadData, leadClientId: leadData, mode: "EC", menuName: "MyClientEc" },
              }}
            >
              <span>{row.leadNo}</span>
            </Link>
          </div>
        )
      },
      csvExport: false,
      headerStyle: {
        minWidth: "110px",
      },
    },

    {
      dataField: "clientType",
      text: "Client Type",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "100px",
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      formatter: (cellContent) => {

        let badgeStyle

        // Determine the badge style based on cell content
        switch (cellContent) {
          case "Green":
            badgeStyle = { backgroundColor: "#28a745" } // Bootstrap success color 
            break
          case "Yellow":
            badgeStyle = { backgroundColor: "#fce303" } // Yellow color
            break
          case "Orange":
            badgeStyle = { backgroundColor: "#FFA500" } //  orange color
            break
          case "Blue":
            badgeStyle = { backgroundColor: "#033dfc" } // Blue color
            break
          default:
            badgeStyle = {}
        }


        return (
          <div style={{ textAlign: "center", justifyContent: "center" }}>
            {cellContent ? (
              <span
                className={"badge"}
                style={{
                  ...badgeStyle,
                  display: "inline-block",
                  width: "35px",        // Equal width and height for a circle
                  height: "35px",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <span>--</span>
              // Show '--' if cellContent is empty
            )}
          </div>)

      }
    },//
    {
      dataField: "onlyEngagement",
      text: "Only Engagement",
      hidden: false,
      editable: false,
      formatter: (cellContent,row) => {

        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#c5ff00",
                    backgroundColor: "#c5ff00"
                  }}
                /> : "--"}
              </div>
              {row.onlyEngagementStatus?`(${row.onlyEngagementStatus})`:""}
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "goodLookingClient",
      text: "Good Looking Client",
      hidden: false,
      editable: false,
      formatter: (cellContent) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#FFD700",
                    backgroundColor: "#BF55EC"
                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "highEndClient",
      text: "High End Client",
      hidden: false,
      editable: false,
      formatter: (cellContent) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#BF55EC",
                    backgroundColor: "#FFD700"

                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        textTransform: "uppercase",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "leadServiceName",
      text: "Service",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "leadSourceName",
      text: "Lead Source",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "leadType",
      text: "Lead Type",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        color: "#e40d8c",
        textTransform: "uppercase",
      }),

      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "cpStatus",
      text: "CP Status",
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",

      }),
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",

      }),
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "salesUrge",
      text: "Sales Urge",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "118px",
      },
    },
    {
      dataField: "events",
      text: "No of Events",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">{row.events}</span>
          </div>
        )
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "allowOrder",
      text: "Allow Order",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      formatter: (cellContent, row) => {
        return (
          <div>
            <Badge
              color={row.allowOrderData === true ? "success" : "danger"}
              style={{ padding: "6px", fontSize: "12px" }}
            >
              {" "}
              {row.allowOrder}
            </Badge>
          </div>
        )
      },
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "overallStatus",
      text: "Overall Status",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        color: "#e40d8c",
        fontWeight: 600,
      }),
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "salesAgentName",
      text: "Sales Agent Name",
      // sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      fontWeight: 600,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "clearanceReport",
      text: "Clearance Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="d-flex flex-row justify-content-between">
            <Button
              onClick={() => {
                if (
                  row.leadClearanceStatusId === "PS22" ||
                  row.leadClearanceStatusId === "PS24"
                ) {
                  setClearanceModal(false)
                } else {
                  setClearanceModal(true)
                  setLeadId(row._id)
                }
              }}
              style={{
                display: "inline-block",
                border: "none",
                cursor: "pointer",
                color: "white",
                background:
                  row.leadClearanceType === "paid"
                    ? "#34c28f"
                    : row.leadClearanceType === "partialPaid" ||
                      row.leadClearanceType === "partialpaid"
                      ? "#f9851b"
                      : row.leadClearanceType === "Exception" ||
                        row.leadClearanceType === "exception"
                        ? "#F1B44C"
                        : row.leadClearanceType === "complementary" ||
                          row.leadClearanceType === "Complementary"
                          ? "#50a5f1"
                          : "#c31919ed",
                padding: "6px",
                borderRadius: "4px",
              }}
            >
              {row.leadClearanceStatusId === "PS21" ||
                row.leadClearanceStatusId === "PS23" ||
                row.leadClearanceStatusId === "PS25"
                ? row.leadClearanceName
                : row.leadClearanceStatusId === "PS22" ||
                  row.leadClearanceStatusId === "PS24"
                  ? row.leadClearanceName
                  : row.leadClearanceName}
            </Button>
            {/* )} */}
            <div
              className="mx-2 mt-2"
              onClick={() => {
                setClearanceHistoryDetails(row.leadClearanceHistory)
                setClearanceHistoryModal(true)
              }}
            >
              <i
                className="fas fa-eye"
                style={{ color: "#50a5f1", fontSize: "13px" }}
              ></i>
            </div>
          </div>
        )
      },
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "210px",
      },
    },
    {
      dataField: "leadStatus",
      text: "EC Status",
      sort: true,
      style: (cell, row) => ({
        backgroundColor: row.alter === true ? "#3abd856e" : "",
        textTransform: "uppercase",
      }),

      formatter: (cellContent, row) => {
        return (
          <button
            style={{
              background: row.colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "4px 6px",
              borderRadius: "4px",
            }}
          >
            {row.statusName}
          </button>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]

  //Pagination section start
  //Search filter
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
  console.log(searchInput, "searchInput")

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    specificDispatch(
      myClientAction.loadMyClientEcList({
        searchFilter: searchInput,
        isManageEC: true,
        employeeId: empId,
        page: pageChange ? pageCount : 1,
        limit: 25,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""

    var searchFromDate =
      myClientEcData && myClientEcData.fromDate
        ? moment(myClientEcData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      myClientEcData && myClientEcData.toDate
        ? moment(myClientEcData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      myClientEcData && myClientEcData.leadNo ? myClientEcData.leadNo : ""
    var searchAlter = isAlter
    var searchvalue = {}
    searchvalue.isManageEC = true
    searchvalue.employeeId = empId
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 25
    if (searchAlter) {
      searchvalue.isAlter = searchAlter
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_all_ec_unassigned_lead`, searchvalue)
      .then((response) => {
        console.log(response.data, "response")

        const unassignedExcelDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const leadDate = data.leadDate
              ? moment(data.leadDate)
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format(`${dateFormate} hh:mm A`)
              : []
            const eventCount =
              !isEmpty(data) && data.events.length > 0
                ? data.events.length
                : 0

            const groomName = !isEmpty(data.groomName)
              ? JSON.stringify(data.groomName).replace(/","/g, "\n")
              : "--"
            const brideName = !isEmpty(data.brideName)
              ? JSON.stringify(data.brideName).replace(/","/g, "\n")
              : "--"
            const cpRemarks = !isEmpty(data.clientDetails) ?
              data.clientDetails.profileRemarks : ""
            const cpRemarksValue = !isEmpty(cpRemarks)
              ? cpRemarks.replace(/[\r\n,.]/gm, "")
              : "--"
            return {
              _id: data._id,
              sNo: index + 1,
              leadNo: data.leadNo,
              branchId: data.branchId,
              routeData: data,
              leadNoData: data.leadNo,
              branchName: data.branchName,
              clientName: !isEmpty(data.clientDetails)
                ? data.clientDetails.firstName +
                " " +
                data.clientDetails.lastName
                : "",
              brideName: brideName,
              groomName: groomName,
              companyId: data.companyId,
              companyName: data.companyName,
              leadServiceName: data.leadServiceName,
              leadSourceName: data.leadSourceName,
              leadType: data.leadType,
              salesUrge: data.salesUrge,
              overallStatus: !isEmpty(data.overAllStatus)
                ? data.overAllStatus
                : "--",
              paymentStatus: !isEmpty(data.paymentStatus)
                ? data.paymentStatus
                : "",
              allowOrderData: data.isAllowOrder,
              allowOrder: data.isAllowOrder === true ? "YES" : "NO",
              eventDetails: data.events,
              clientCode: !isEmpty(data.clientDetails)
                ? data.clientDetails.clientNo
                : "",
              events: eventCount,
              ecAssign: isEmpty(data.ecProcessStatus)
                ? "Unassigned"
                : "Assigned",
              assignedEcName: !isEmpty(data.leadECAssign)
                ? data.leadECAssign.assignedToName
                : "--",
              assignedEcId: !isEmpty(data.leadECAssign)
                ? data.leadECAssign.assignedTo
                : "",
              salesAgentName: !isEmpty(data.leadAssign)
                ? data.leadAssign.assignedToName
                : "--",
              leadClearanceType: !isEmpty(data.leadClearance)
                ? data.leadClearance.type
                : "--",
              leadClearanceStatusId: !isEmpty(data.ecClearanceStatus)
                ? data.ecClearanceStatus
                : "",
              leadClearanceName: !isEmpty(data.ecClearanceStatusName)
                ? data.ecClearanceStatusName
                : "--",
              leadDate: leadDate,
              ecProcessStatus: data.ecProcessStatus,
              ecProcessStatusName: data.ecProcessStatusName,
              clearanceReport:
                data.ecProcessStatus !== "PS2"
                  ? data.ecProcessStatusName
                  : "--",
              cpRemarks: cpRemarksValue,
              cpStatus: !isEmpty(data.clientDetails) ?
                data.clientDetails.profileStatus : "--",
              key: index,
              clientType: data.leadQuotationRange,
              onlyEngagement: data.onlyEngagement == true ? "YES" : "NO",
              onlyEngagementStatus:data. onlyEngagementStatus,
              goodLookingClient: data.goodLookingClient == true ? "YES" : "NO",
              highEndClient: data.highEndClient == true ? "YES" : "NO",

            }
            // }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "S.No,Lead No,Good Looking Client,High End CLient,Client Type, Only Engagement,Company,Branch,Client Code,Client Name,CP Status, CP Remarks,Bride Name,Groom Name, Lead Date, Ec Agent Name,No of Events,Allow Order, Overall Status,Sales Agent, Clearance Report, Ec Status",
          ]

          let usersCsv = !isEmpty(unassignedExcelDataTable)
            ? unassignedExcelDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                goodLookingClient,
                highEndClient,
                clientType,
                onlyEngagement,
                companyName,
                branchName,
                clientCode,
                clientName,
                cpStatus,
                cpRemarks,
                brideName,
                groomName,
                leadDate,
                assignedEcName,
                events,
                allowOrder,
                overallStatus,
                salesAgentName,
                leadClearanceName,
                ecProcessStatusName,
              } = user
              acc.push([
                sNo,
                leadNo,
                goodLookingClient,
                highEndClient,
                clientType,
                onlyEngagement,
                companyName,
                branchName,
                clientCode,
                clientName,
                cpStatus,
                cpRemarks,
                brideName,
                groomName,
                leadDate,
                assignedEcName,
                events,
                allowOrder,
                overallStatus,
                salesAgentName,
                leadClearanceName,
                ecProcessStatusName,
              ])

              console.log("test", acc)
              return acc
            }, [])
            : false
          console.log(usersCsv, "usersCsv")

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "MyClientEC.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>

                      <Col md="8" sm="12">
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginBottom: "20px",
                              marginTop: "-41px",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginTop: "-30px",
                            marginRight: "20px"
                          }}

                        >
                          <div className="d-flex flex-row">
                            <div className="quote-altered-lead"></div>
                            <h6 className="alter-font">
                              Quote Altered Lead
                            </h6>
                          </div>
                          <div>
                            <h6 className="cp-font">
                              CP - Client Profile
                            </h6>
                          </div>
                        </div>
                      </Col>

                      <Col id="my-component">
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive

                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                          expandRow={expandRow}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )

  const [state, setState] = useState({
    sizePerPage: 25,
    page: 1,
    totalSize: manageEc_details.length,
    data:
      !isEmpty(manageEc_details) && manageEc_details.length > 0
        ? manageEc_details.slice(0, 25)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(manageEc_details.data) && manageEc_details.data.length > 0
        ? manageEc_details.data
        : []

    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""

    var searchFromDate =
      myClientEcData && myClientEcData.fromDate
        ? moment(myClientEcData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      myClientEcData && myClientEcData.toDate
        ? moment(myClientEcData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      myClientEcData && myClientEcData.leadNo ? myClientEcData.leadNo : ""
    var searchAlter = isAlter
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.employeeId = empId
    searchvalue.isManageEC = true
    searchvalue.limit = sizePerPage
    if (searchAlter) {
      searchvalue.isAlter = searchAlter
    }
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    specificDispatch(myClientAction.loadMyClientEcList(searchvalue))

    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 1400)
    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Time
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Food
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Travel
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Location
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Venue Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Crowd Strength
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.eventDetails.length > 0 ? (
              row.eventDetails.map((data) => {
                console.log(data, "row list data")

                const dateFormate =
                  !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

                console.log(dateFormate, "dateFormate")
                const eventFromDate = moment(data.eventDate).format(
                  "YYYY-MM-DD"
                )
                console.log(eventFromDate, "eventFrom Date")
                const eventDate = new Date(data.eventDate)
                console.log(eventDate, "eventDate")
                if (
                  new Date(data.eventDate) >=
                  new Date(myClientEcData.fromDate) &&
                  new Date(data.eventDate) <= new Date(myClientEcData.toDate)
                ) {
                  console.log(data, "expandRow data")
                  const rowStyle = data.isAlter === true ? { backgroundColor: "#3abd856e" } : {}
                  return (
                    <tr key={data._id}>
                      <th scope="data" style={rowStyle}>{data.eventNo}</th>
                      <td style={rowStyle}>{data.eventName}</td>
                      <td style={rowStyle}>{moment(data.eventDate).format(dateFormate)}</td>
                      <th style={rowStyle}>{data.crewAssemblyTime}</th>
                      <th style={rowStyle}>{data.food}</th>
                      <th style={rowStyle}>{data.travelStay}</th>
                      <td style={rowStyle}>{data.venueLocation}</td>
                      <td style={rowStyle}>{data.venueName}</td>
                      <td style={rowStyle}>{data.crowdStrength}</td>
                    </tr>
                  )
                } else if (
                  isEmpty(myClientEcData.fromDate) &&
                  isEmpty(myClientEcData.toDate)
                ) {
                  const rowStyle = data.isAlter === true ? { backgroundColor: "#3abd856e" } : {}
                  return (
                    <tr key={data._id}>
                      <th scope="data" style={rowStyle}>{data.eventNo}</th>
                      <td style={rowStyle}>{data.eventName}</td>
                      <td style={rowStyle}>{moment(data.eventDate).format(dateFormate)}</td>
                      <th style={rowStyle}>{data.crewAssemblyTime}</th>
                      <th style={rowStyle}>{data.food}</th>
                      <th style={rowStyle}>{data.travelStay}</th>
                      <td style={rowStyle}>{data.venueLocation}</td>
                      <td style={rowStyle}>{data.venueName}</td>
                      <td style={rowStyle}>{data.crowdStrength}</td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  //get today's date
  const current = new Date()
  const date = `${current.getMonth() + 1
    }-${current.getDate()}-${current.getFullYear()}`
  console.log(date, "today date")

  //Add Clearance
  const addClearance = () => {
    const applyClearance = {
      leadId: leadId,
      mode: "LEVEL1",
      type: "unpaid",
      clearanceDate: date,
      clearanceBy: empId,
      clearanceStatus: "PS21",
      remarks: "",
    }
    console.log(applyClearance, "applyClearance")
    specificDispatch(manageEcAction.addClearance(applyClearance))
    setTimeout(() => {
      dispatch(myClientAction.loadMyClientEcList(searchValue))
      setClearanceModal(false)
    }, 1000)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            myClientMetaData
                              ? myClientMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            myClientMetaData
                              ? myClientMetaData.eventOptions
                              : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={myClientEcData.fromDate}
                          max={myClientEcData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={myClientEcData.toDate}
                          min={myClientEcData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={myClientEcData.leadNo}
                          // min={myClientEcData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-5">
                        <div className="d-flex flex-row">
                          {alterList.map((data, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="isAlter"
                                  value={data.value}
                                  checked={isAlter === data.value}
                                  onChange={(e) =>
                                    handleAlterChange(e, data.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {data.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => clientFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBarStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  {/* <div className="d-flex flex-row">
                    
                    
                  </div> */}
                  <RemotePagination
                    data={myClientDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(manageEc_details)
                        ? manageEc_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/* Clearance history modal */}
          {clearanceHistoryModal && (
            <Modal
              show={clearanceHistoryModal}
              onHide={handleClearanceHistory}
              size="lg"
              backdrop="static"
            >
              <Modal.Header style={{ backgroundColor: "#E40D8C" }}>
                <h5 style={{ color: "white" }}>Clearance Status History</h5>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Col lg="12" md="12" sm="12" xs="12">
                    <Table bordered striped responsive>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Clearance Date</th>
                          <th>Payment Status</th>
                          <th>Level</th>
                          <th>Payment %</th>
                          <th>Remarks</th>
                          <th>Attachment</th>
                          <th>Status</th>
                          <th>Created By</th>
                          <th>Created On</th>
                        </tr>
                      </thead>
                      <tbody>
                        {clearanceHistoryDetails &&
                          clearanceHistoryDetails.length > 0 ? (
                          clearanceHistoryDetails.map((data, index) => {
                            const attachment = !isEmpty(data.attachment)
                              ? data.attachment
                              : ""
                            const clearanceDate = !isEmpty(data.clearanceDate)
                              ? moment(data.clearanceDate)
                                .subtract(5, "hours")
                                .subtract(30, "minutes")
                                .format(dateFormate)
                              : []
                            const createdAt = !isEmpty(data.CreatedOn)
                              ? moment(data.CreatedOn)
                                .subtract(5, "hours")
                                .subtract(30, "minutes")
                                .format(dateFormate)
                              : []
                            const processStatusName =
                              !isEmpty(myClientMetaData) &&
                                !isEmpty(myClientMetaData.processStatusOptions) &&
                                myClientMetaData.processStatusOptions &&
                                myClientMetaData.processStatusOptions.length > 0
                                ? myClientMetaData.processStatusOptions.find(
                                  (_) =>
                                    _.processStatusId == data.clearanceStatus
                                )
                                : "--"
                            return (
                              <>
                                <tr key={data._id}>
                                  <td>{index + 1}</td>
                                  <td>{clearanceDate}</td>
                                  <td>{data.paymentType}</td>
                                  <td>{data.mode}</td>
                                  <td>{data.paymentReceivedPercentage}</td>

                                  <td>{data.remarks}</td>
                                  <td>
                                    {" "}
                                    <a
                                      onClick={() =>
                                        window.open(attachment, "_blank")
                                      }
                                    >
                                      <span
                                        style={{
                                          color: "#e40d8c",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        View
                                      </span>
                                    </a>
                                  </td>
                                  <td>
                                    <button
                                      style={{
                                        background:
                                          data.paymentType == "paid"
                                            ? "#34c28f"
                                            : data.paymentType ==
                                              "partialpaid" ||
                                              data.paymentType == "partialPaid"
                                              ? "#f9851b"
                                              : data.paymentType === "Exception" ||
                                                data.paymentType === "exception"
                                                ? "#F1B44C"
                                                : data.paymentType === "complementary" ||
                                                  data.paymentType === "Complementary"
                                                  ? "#50a5f1"
                                                  : "#c31919ed",
                                        border: "none",
                                        cursor: "pointer",
                                        color: "white",
                                        padding: "4px 6px",
                                        borderRadius: "4px",
                                      }}
                                    >
                                      {processStatusName.label}
                                    </button>
                                  </td>
                                  <td>{data.insertedByName}</td>
                                  <td>{createdAt}</td>
                                </tr>
                              </>
                            )
                          })
                        ) : (
                          <tr key={0}>
                            <td colSpan={10} className="text-align-center">
                              {"No Data Found"}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  onClick={handleClearanceHistory}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {clearanceModal && (
            <Modal
              show={clearanceModal}
              size="md"
              style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Clearance Report</span>
                </div>
              </Modal.Header>
              <Modal.Body>Do You Want To Clearance The Report?</Modal.Body>

              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      setClearanceModal(false)
                    }}
                    // style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      setClearanceModal(false)
                      addClearance()
                    }}
                    style={{ marginLeft: "20px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Confirm
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {downloadLoading ? (
            <Modal
              show={downloadLoading}
              style={{ width: "7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

MyClientEc.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MyClientEc)
)
